'use client';

import { Menu } from '@/lib/types';
import { createURL } from '@/lib/utils';
import { CustomLink } from '@/ui';
import { Box } from '@mantine/core';

export default function Links({ links }: { links: Menu[] }) {
  return (
    <div className="flex justify-center flex-wrap gap-x-[3rem] gap-y-[0.5rem]">
      {links?.map((link) => (
        <Box key={link?.id}>
          <CustomLink
            href={createURL(link?.url)}
            target={link?.target}
            className="font--sm font-medium uppercase hover:underline"
          >
            {link?.title}
          </CustomLink>
        </Box>
      ))}
    </div>
  );
}
